module.exports = __webpack_public_path__ + "img/img_zjmx.72aba6ac.webp";